export const setVisited = () => {
  localStorage.setItem("visited", "true");
};

export const hasVisited = () => {
  return localStorage.getItem("visited") === "true";
};
